import {
  SUPPORT_CHECKS_FILTER_NAME,
  SUPPORT_CHECKS_FILTER_VALUE,
} from 'helpers/check-type-filter-options';
import moment from 'moment';

export const VIEW_CHECKS = 'checks';
export const VIEW_SUBCHECKS = 'subchecks';

export const VIEW_FILTER_OPTIONS = [
  { name: 'Checks', value: VIEW_CHECKS },
  { name: 'Subchecks', value: VIEW_SUBCHECKS },
];

export const resolveAdminChecksView = view =>
  view === VIEW_SUBCHECKS ? VIEW_SUBCHECKS : VIEW_CHECKS;

export const isSubcheckView = view => resolveAdminChecksView(view) === VIEW_SUBCHECKS;

export const STILL_BEING_WORKED_ON_STATUS_VALUES = ['in-progress', 'submitted', 'deferred'];
export const STILL_BEING_WORKED_ON_STATUS_NAMES = ['In Progress', 'Submitted', 'Deferred'];

export const NON_BLOCKED_IN_PROGRESS_SUB_STATUS_VALUES = [
  'processing',
  'waiting_on_client',
  'waiting_on_candidate',
  'waiting_on_provider',
];
export const NON_BLOCKED_IN_PROGRESS_SUB_STATUS_NAMES = [
  'Processing',
  'Waiting on Client',
  'Waiting on Candidate',
  'Waiting on Provider',
];

export const CHECKS_VIEW_FILTER = { value: VIEW_CHECKS, name: 'Checks' };
export const SUBCHECKS_VIEW_FILTER = { value: VIEW_SUBCHECKS, name: 'Subchecks' };

export const SUPPORT_CHECKS_TYPE_FILTER = {
  value: [SUPPORT_CHECKS_FILTER_VALUE],
  name: [SUPPORT_CHECKS_FILTER_NAME],
  type: 'status',
};

export const buildStillBeingWorkedOnStatusFilter = (
  names = STILL_BEING_WORKED_ON_STATUS_NAMES,
) => ({
  value: STILL_BEING_WORKED_ON_STATUS_VALUES,
  name: names,
  type: 'status',
});

export const NON_BLOCKED_IN_PROGRESS_SUB_STATUS_FILTER = {
  value: NON_BLOCKED_IN_PROGRESS_SUB_STATUS_VALUES,
  name: NON_BLOCKED_IN_PROGRESS_SUB_STATUS_NAMES,
  type: 'status',
};

export const WORKING_QUEUE_PARAMS = {
  status: buildStillBeingWorkedOnStatusFilter(),
  check_type: SUPPORT_CHECKS_TYPE_FILTER,
  in_progress_sub_status: NON_BLOCKED_IN_PROGRESS_SUB_STATUS_FILTER,
  page: { value: 1 },
};

export const WORKING_QUEUE_ENFORCED = {
  status: STILL_BEING_WORKED_ON_STATUS_VALUES.join(','),
  check_type: SUPPORT_CHECKS_FILTER_VALUE,
  in_progress_sub_status: NON_BLOCKED_IN_PROGRESS_SUB_STATUS_VALUES.join(','),
};

export const OVERDUE_SUPPORT_STATUS_FILTER = {
  value: ['overdue_support'],
  name: ['Overdue Support'],
};

export const NEXT_ACTION_DUE_FILTER = {
  value: ['due'],
  name: ['Due'],
};

export const DEFERRED_STATUS_FILTER = {
  value: ['deferred'],
  name: ['Deferred'],
};

export const MY_CHECKS_PARAMS = {
  ...WORKING_QUEUE_PARAMS,
  view: CHECKS_VIEW_FILTER,
  my_checks: { value: 1 },
};

export const MY_SUB_CHECKS_PARAMS = {
  ...WORKING_QUEUE_PARAMS,
  view: SUBCHECKS_VIEW_FILTER,
  my_checks: { value: 1 },
};

export const ALL_CHECKS_PARAMS = {
  ...WORKING_QUEUE_PARAMS,
  view: CHECKS_VIEW_FILTER,
};

export const ALL_SUB_CHECKS_PARAMS = {
  ...WORKING_QUEUE_PARAMS,
  view: SUBCHECKS_VIEW_FILTER,
};

export const workFilterParam = (value, name) => ({
  value: [value],
  name: [name],
  type: 'status',
});

export const auditFilterParam = (value, name) => ({
  value: [value],
  name: [name],
  type: 'status',
});

export const statusFilterParam = (value, name) => ({
  value: [value],
  name: [name],
  type: 'status',
});

export const supportUserFilterParam = (id, name) => ({
  value: id,
  name,
  type: 'status',
});

export const buildPrioritizeViewParams = (value, name, { supportUser } = {}) => ({
  ...WORKING_QUEUE_PARAMS,
  view: CHECKS_VIEW_FILTER,
  work: workFilterParam(value, name),
  ...(supportUser
    ? { support_user: supportUserFilterParam(supportUser.id, supportUser.name) }
    : {}),
});

export const issuesFilterParam = (values, names) => ({
  value: values,
  name: names,
  type: 'status',
});

export const submittedWithin90DaysFilter = () => {
  const to = moment().format('YYYY-MM-DD');
  const from = moment().subtract(90, 'days').format('YYYY-MM-DD');
  return {
    title: 'Submitted',
    name: 'Submitted',
    value: [from, to],
    type: 'date_range',
  };
};

export const buildIssuesViewParams = (values, names) => ({
  ...WORKING_QUEUE_PARAMS,
  view: CHECKS_VIEW_FILTER,
  issues: issuesFilterParam(values, names),
  submitted_at: submittedWithin90DaysFilter(),
});

export const buildMissingResultViewParams = () => ({
  page: { value: 1 },
  view: CHECKS_VIEW_FILTER,
  check_type: SUPPORT_CHECKS_TYPE_FILTER,
  status: statusFilterParam('completed', 'Completed'),
  audit: auditFilterParam('no_upload', 'Missing result file'),
  submitted_at: submittedWithin90DaysFilter(),
});

export const buildUnassignedViewParams = () => ({
  page: { value: 1 },
  view: CHECKS_VIEW_FILTER,
  audit: auditFilterParam('unassigned', 'Unassigned'),
  submitted_at: submittedWithin90DaysFilter(),
});

export const buildAdminChecksDefaultQuery = ({ statusNames } = {}) => ({
  page: 1,
  view: CHECKS_VIEW_FILTER,
  status: buildStillBeingWorkedOnStatusFilter(statusNames),
  check_type: SUPPORT_CHECKS_TYPE_FILTER,
  in_progress_sub_status: NON_BLOCKED_IN_PROGRESS_SUB_STATUS_FILTER,
});
